import React from 'react'

interface ThemeContextValue {
  theme: 'dark' | 'light'
  toggleTheme: () => void
}

export const ThemeContext = React.createContext<ThemeContextValue>({
  theme: (window.localStorage.getItem('color-theme') as 'dark' | 'light') || 'dark',
  toggleTheme: () => {},
})

function ThemeProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const [theme, setTheme] = React.useState<'dark' | 'light'>(() => {
    return (window.localStorage.getItem('color-theme') as 'dark' | 'light') || 'dark'
  })

  React.useEffect(() => {
    window.localStorage.setItem('color-theme', theme)
  }, [theme])

  React.useEffect(() => {
    // Fixes weird issue where toggle would reset on page refresh
    if (theme === 'dark') document.body.classList.toggle('dark', true)
  }, [theme])

  const toggleTheme = React.useCallback(() => {
    document.body.classList.toggle('dark')
    setTheme((currentTheme) => {
      return currentTheme === 'light' ? 'dark' : 'light'
    })
  }, [])

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
